// F098 (A15): WCAG 2.1 AA + §21.7 require interactive controls to expose a
// ≥44×44px touch target. For icon-only controls in the dense Resend-style UI we
// must NOT grow the visual (a 44px icon button breaks the header/list density),
// so we expand the *hit area* with a centered, invisible 44×44 pseudo-element
// instead. The host element must be the click target (a <button>/<a>) — the
// pseudo is part of its box, so taps on the expanded area still fire the
// control. `relative` is included so the pseudo positions against the control.
//
// Text/labelled buttons that can afford the height use `min-h-11` directly
// (44px) rather than this — only reach for HIT_AREA_44 when the visual size
// must stay below 44px.
export const HIT_AREA_44 =
  'relative before:absolute before:left-1/2 before:top-1/2 before:h-11 before:w-11 ' +
  "before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']";
